// The user's locale, and the one place a collator is built from it.
//
// The list holds English and Swedish names side by side, so sorting can't be
// hardcoded to either — the device's own locale decides whether "Ölkorv" goes
// after "Zebrakorv" (Swedish) or among the O's (English). Pure lib functions
// take the locale as an explicit parameter (tests pass one; jsdom's default is
// en-US); components resolve it once with `userLocale()`.

export function userLocale(): string {
  if (typeof navigator !== 'undefined' && navigator.language) return navigator.language
  return 'en'
}

/** A comparator for item/recipe names in the given locale, built once per call. */
export function compareNames(locale: string): (a: string, b: string) => number {
  const collator = new Intl.Collator(locale, { sensitivity: 'base' })
  return (a, b) => collator.compare(a, b)
}
